import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TextareaField from "../../ui/form/TextAreaField";
import apiRequest from "../../../utils/admin/apiRequest";
import toast from "react-hot-toast";

const Page = () => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const pages = setting?.pages || {};

  const defaultPagesData = {
    about_us: pages?.about_us || "",
    contact_us: pages?.contact_us || "",
  };

  const [pagesData, setPagesData] = useState(defaultPagesData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (setting?.pages) {
      setPagesData((prev) => ({
        ...prev,
        ...setting.pages,
      }));
    }
  }, [setting]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPagesData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiRequest.updateSetting({
        data: { pages: pagesData },
      });
      toast.success(response?.data?.message || "Page info updated.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update policy info.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="p-4 space-y-4 bg-white rounded" onSubmit={handleSubmit}>
      <h2 className="text-lg font-semibold text-gray-700">Page Information</h2>

      <TextareaField
        label="About Us"
        id="about_us"
        name="about_us"
        rows={8}
        value={pagesData?.about_us}
        onChange={handleChange}
      />
      <TextareaField
        label="Contact Us"
        id="contact_us"
        name="contact_us"
        rows={8}
        value={pagesData.contact_us}
        onChange={handleChange}
      />
      <button
        type="submit"
        disabled={loading}
        className="px-4 py-2 text-sm text-white rounded bg-primary hover:bg-primaryDark"
      >
        {loading ? "Saving..." : "Update Pages Info"}
      </button>
    </form>
  );
};

export default Page;
